import { nullishDefault } from '../helpers/nullishDefault';
import { RetainMarker } from '../retainMarker';
import { ClassificationDetection } from './classificationDetection';
import { ClassificationMeta } from './classificationMeta';
import { z } from 'zod';

export const SnapshotCameraPosition = z.enum(['Bottom', 'Top']);
export type SnapshotCameraPosition = z.infer<typeof SnapshotCameraPosition>;
export type SnapshotImageBucket = z.infer<typeof SnapshotImageBucket>;
export type SnapshotImageMetadata = z.infer<typeof SnapshotImageMetadata>;

export const SnapshotImageMetadata = z.object({
    angularVelocity: z.unknown(),
    cartMoving: z.unknown(),
    hwVersion: z.string().nullish(),
    linearAcceleration: z.unknown(),
    location: z.unknown(),
    orientation: z.unknown(),
    scale: z.unknown(),
    imageClassification: ClassificationMeta.nullish(),
    additionalImageClassifications: z.record(z.string(), z.array(ClassificationDetection)).nullish(),
});

export const SnapshotImage = z.object({
    camera: SnapshotCameraPosition,
    correlationGuid: z.string(),
    height: z.number(),
    host: z.string(),
    index: z.number(),
    logicalPath: z.string(),
    metadata: nullishDefault(SnapshotImageMetadata, {} as Record<string, never>),
    properties: z.object({ sessionGuid: z.string() }),
    relativePath: z.string(),
    sessionGuid: z.string(),
    timestamp: z.string(),
    trigger: z.string(),
    width: z.number(),
});
export type SnapshotImage = z.infer<typeof SnapshotImage>;

export const SnapshotImageBucket = z.object({
    key: z.string(),
    count: z.number(),
    modifiedEnd: z.coerce.date(),
    modifiedStart: z.coerce.date(),
    changes: SnapshotImage.array(),
    retain: RetainMarker.nullish(),
});
